export default __webpack_public_path__ + "static/media/exam-time.b1be8d50.gif";